import { useMediaQuery, MEDIA_LG } from 'approot/shared/style';
import * as Styled from './breadcrumb.style';

type Breadcrumb = {
  label: string;
  href: string;
  onClick?: () => void;
};

type Props = {
  breadcrumbs: Breadcrumb[];
  breadcrumbsSmall?: Breadcrumb[];
};

const Breadcrumbs = ({ breadcrumbs, breadcrumbsSmall }: Props) => {
  const isMdLgUp = useMediaQuery(MEDIA_LG);
  return (
    <Styled.Breadcrumbs aria-label="Breadcrumb">
      <ul>
        {!isMdLgUp && breadcrumbsSmall
          ? breadcrumbsSmall.map((b, i) => (
              <li key={b.href}>
                <Styled.BreadcrumbArrowReverse />
                <Styled.BreadcrumbLink
                  data-selector="breadcrumb"
                  to={b.href}
                  onClick={b.onClick}
                >
                  {b.label}
                </Styled.BreadcrumbLink>
              </li>
            ))
          : breadcrumbs.map((b, i) => {
              return (
                <li key={b.href}>
                  {i > 0 && <Styled.BreadcrumbArrow />}
                  {i === breadcrumbs.length - 1 ? (
                    <Styled.Breadcrumb
                      aria-current="page"
                      data-selector="breadcrumb"
                    >
                      {b.label}
                    </Styled.Breadcrumb>
                  ) : (
                    <Styled.BreadcrumbLink
                      data-selector="breadcrumb"
                      to={b.href}
                      onClick={b.onClick}
                    >
                      {b.label}
                    </Styled.BreadcrumbLink>
                  )}
                </li>
              );
            })}
      </ul>
    </Styled.Breadcrumbs>
  );
};

export default Breadcrumbs;
